import compareAsc from 'date-fns/compareAsc'
import addDays from 'date-fns/addDays'
import fnsStartOfWeek from 'date-fns/startOfWeek'
import fnsEndOfWeek from 'date-fns/endOfWeek'
import getWeek from 'date-fns/getWeek'
import getYear from 'date-fns/getYear'
import deLocale from 'date-fns/locale/de'

import Fuse from 'fuse.js'

import filterStore from '@/Store/filter'
import ordersStockStore from '@/Store/ordersStock'

import { ordersByWeek, productsForWeekOrder } from './queries.js'

export default {
  data: () => ({
    filter: filterStore.state,
    ordersStock: ordersStockStore.state,
    startOfWeek: null,
    loadingOrders: 0,
    loadingProducts: 0,
    fuse: new Fuse([], {
      keys: ['name', 'item_number']
    })
  }),

  beforeCreate() {
    this.fuse = new Fuse([], {
      keys: ['name', 'item_number']
    })
  },

  computed: {
    week() {
      let date = this.$page.props.nextPossibleOrderDay ? this.$page.props.nextPossibleOrderDay : this.now

      return this.startOfWeek ? this.startOfWeek : fnsStartOfWeek(
        new Date(date),
        { weekStartsOn: 1 }
      )
    },

    year() {
      return this.weekNumber === 1 ? getYear(fnsEndOfWeek(this.week, { weekStartsOn: 1 })) : getYear(this.week)
    },

    weekNumber() {
      return getWeek(this.week, { weekStartsOn: 1, locale: deLocale })
    },

    weekDates() {
      const weekEnd = fnsEndOfWeek(this.week, { weekStartsOn: 1 })
      let day = fnsStartOfWeek(this.week, { weekStartsOn: 1 })
      let dates = []

      while (compareAsc(day, weekEnd) < 0) {
        dates.push(day)
        day = addDays(day, 1)
      }

      return dates
    },

    products() {
      if (this.filter.search !== '') {
        return this.fuse.search(this.filter.search)
      }

      const products = this.productsForWeekOrder?.data.map(function (product) {
        return {item: product}
      }) ?? []

      return products
    },

    loading() {
      return this.loadingOrders > 0 || this.loadingProducts > 0
    }
  },

  watch: {
    ordersByWeek: function(newValue, oldValue) {
      ordersStockStore.setWeekDates(this.weekDates)
      ordersStockStore.setExcludedDates(newValue?.excludedDays ?? [])
      ordersStockStore.addOrdersToStock(newValue?.data ?? [])
    }
  },

  apollo: {
    ordersByWeek: {
      query: ordersByWeek,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      loadingKey: 'loadingOrders',
      variables () {
        return {
          week: this.weekNumber,
          year: this.year,
        }
      },
    },

    productsForWeekOrder: {
      query: productsForWeekOrder,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      loadingKey: 'loadingProducts',
      variables () {
        return {
          year: this.year,
          week: this.weekNumber,
          categoryId: this.filter.categories.length > 0 ? this.filter.categories[0] : undefined,
          tagIds: this.filter.tags.length > 0 ? this.filter.tags : undefined,
        }
      },
      result (responseObject) {
        // console.log(responseObject?.data?.productsForWeekOrder.data ?? [])
        this.fuse.setCollection(responseObject?.data?.productsForWeekOrder.data ?? [])
      },
    },
  },

  methods: {
    setWeek(startOfWeek) {
      this.startOfWeek = startOfWeek
    }
  }
}
